module.exports = __webpack_public_path__ + "static/media/main3.2a8ed3f6.svg";